import { Platform, StyleSheet, View } from 'react-native';

import { IconInfoFill, Text, tokens } from '@fhs/ui';
import { CHECKOUT_NO_REFUND_CALLOUT } from '@fhs-legacy/frontend/src/utils/test-ids';

export default function NoRefundCallout() {
  const isWeb = Platform.OS === 'web';

  return (
    <View
      testID={CHECKOUT_NO_REFUND_CALLOUT}
      style={styles.locationCalloutContainer}
      {...(isWeb ? ({ tabIndex: 0 } as const) : {})}
    >
      <View
        accessibilityElementsHidden
        importantForAccessibility="no-hide-descendants"
        {...(Platform.OS === 'web' ? { 'aria-hidden': true } : {})}
      >
        <IconInfoFill />
      </View>
      <Text.Ui size="sm" numberOfLines={2}>
        No refunds for orders to the wrong location
      </Text.Ui>
    </View>
  );
}

const styles = StyleSheet.create({
  locationCalloutContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    marginHorizontal: 16,
    marginBottom: 20,
    paddingVertical: 12,
    paddingHorizontal: 16,
    backgroundColor: tokens.colors.$houseLight,
    flex: 1,
    borderRadius: 8,
  },
});
